window.initWaitlistModal = function(waitlistModal) {
  if (waitlistModal) {
    const emailInput = waitlistModal.querySelector('input[type="email"]');
    const emailLabel = waitlistModal.querySelector('label[for="' + (emailInput ? emailInput.id : '') + '"]');
    const checkboxLabel = waitlistModal.querySelector('.form-consent__checkbox label');
    const checkbox = waitlistModal.querySelector('.form-consent__checkbox input[type="checkbox"]');
    const checkboxContainer = waitlistModal.querySelector('.form-consent__checkbox');
    const emailErrorMsg = waitlistModal.querySelector('.field__error-message');
    const ctaButton = waitlistModal.querySelector('.newsletter-submit');

    function validateForm() {
      if (!emailInput || !checkbox) return;
      if (emailInput.classList.contains("error") || !checkbox.checked) {
        ctaButton.classList.add("disabled");
        ctaButton.setAttribute("disabled", "true");
      } else {
        ctaButton.classList.remove("disabled");
        ctaButton.removeAttribute("disabled");
      }
    }

    if (emailInput) {
      emailInput.addEventListener('click', function () {
        if (checkboxLabel) {
          checkboxContainer.classList.remove('hide-on-load');
          checkboxLabel.style.display = "flex";
        }
      });

      emailInput.addEventListener('blur', function () {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(emailInput.value.trim())) {
          emailInput.classList.add("field__input", "error");
          if (emailLabel) {
            emailErrorMsg.style.display = 'block'
          }
        } else {
          emailInput.classList.remove("field__input", "error");
          if (emailLabel) {
            emailErrorMsg.style.display = 'none'
          }
        }
        validateForm();
      });
    }

    if (checkbox) {
      checkbox.addEventListener('change', validateForm);
    }

    ctaButton.addEventListener('click', function () {
      if (ctaButton.classList.contains('disabled')) return;

      // Show the success message
      const successMessage = waitlistModal.querySelector('#WaitlistNewsletter-success');
      const fieldWrapper = waitlistModal.querySelector('.newsletter-form__field-wrapper');
      const errorMessage = waitlistModal.querySelector('#WaitlistNewsletter-error');
      const emailHeader = waitlistModal.querySelector('.email-container .heading-2');

      if (successMessage) successMessage.style.display = 'block';
      if (fieldWrapper) fieldWrapper.style.display = 'none';
      if (errorMessage) errorMessage.style.display = 'none';
      if (emailHeader) emailHeader.style.display = 'none';
    });

    // reset modal when going from product to product
    function resetWaitlistModal(waitlistModal) {
      const successMessage = waitlistModal.querySelector('#WaitlistNewsletter-success');
      const fieldWrapper = waitlistModal.querySelector('.newsletter-form__field-wrapper');
      const errorMessage = waitlistModal.querySelector('#WaitlistNewsletter-error');
      const emailHeader = waitlistModal.querySelector('.email-container .heading-2');
      const emailInput = waitlistModal.querySelector('input[type="email"]');
      const checkbox = waitlistModal.querySelector('.form-consent__checkbox input[type="checkbox"]');
      const emailLabel = waitlistModal.querySelector('label[for="' + (emailInput ? emailInput.id : '') + '"]');
      const ctaButton = waitlistModal.querySelector('.newsletter-submit');

      if (successMessage) successMessage.style.display = 'none';
      if (fieldWrapper) fieldWrapper.style.display = 'block';
      if (errorMessage) errorMessage.style.display = 'none';
      if (emailHeader) emailHeader.style.display = 'block';
      if (emailInput) {
        emailInput.value = '';
        emailInput.classList.remove("error");
        if (emailLabel) emailLabel.textContent = 'Email';
      }
      if (checkbox) checkbox.checked = false;
      if (ctaButton) {
        ctaButton.classList.add("disabled");
        ctaButton.setAttribute("disabled", "true");
      }
    }

    document.body.addEventListener('modalClosed', function(e) {
      if (e.detail === waitlistModal.id) {
        resetWaitlistModal(waitlistModal);
      }
    });
  }

  function getSelectedVariantFromPDP(selectedInput) {
    const pickerWrapper = selectedInput.closest('[data-picker-type]');
    if (!pickerWrapper) return null;

    const sectionId = pickerWrapper.dataset.section || pickerWrapper.id?.split('-').pop();
    if (!sectionId) return null;

    const variantDataElement = document.getElementById(`ProductVariants-${sectionId}`);
    if (!variantDataElement) return null;

    const variantData = JSON.parse(variantDataElement.textContent);

    const swatches = pickerWrapper.querySelectorAll('.swatch-input__input:checked');
    const selectedValues = Array.from(swatches).map(input => ({
      index: parseInt(input.dataset.optionIndex, 10),
      value: input.value.trim()
    }));

    const matchedVariant = variantData.find(variant => {
      return selectedValues.every(sel => variant.options[sel.index] === sel.value);
    });

    return matchedVariant;
  }

  // Replace the existing document.body.addEventListener("click", ...) block with this:
  document.body.addEventListener("change", function (event) {
 
    if (event.target.matches(".swatch-input__input") && event.target.checked) {
      // Only update waitlist modal content when the newly selected shade is out of stock.
      const selectedInput = event.target;
      const isExplicitlyOos = selectedInput.dataset.variantAvailable === 'false';
      const hasOosClass =
        selectedInput.classList.contains('shade--not-available') ||
        selectedInput.classList.contains('visually-disabled') ||
        selectedInput.closest('.shade-variant')?.classList.contains('oos');

      if (!isExplicitlyOos && !hasOosClass) {
        return;
      }
      // data variant update
      const selectedVariant = getSelectedVariantFromPDP(selectedInput);
      const shadeDetailsElement = waitlistModal.querySelector(".waitlist-modal__content-info .shade-details");
      if (shadeDetailsElement && selectedInput.dataset.variantId) {
        shadeDetailsElement.setAttribute("data-variant-id", selectedInput.dataset.variantId);
      }
  
      // product title and price
      const parentTitleElement = waitlistModal.querySelector(".waitlist-modal__content-info .product-container p.waitlist-product-title");
      const parentPriceElement = waitlistModal.querySelector(".waitlist-modal__content-info .product-container p.waitlist-product-price");
  
      if (parentTitleElement) parentTitleElement.textContent = selectedInput.title;
      if (parentPriceElement) parentPriceElement.textContent = selectedInput.dataset.variantPrice;
  
      // variant title and desc
      let variantTitleElement = waitlistModal.querySelector(".waitlist-modal__content-info .shade-details p.paragraph-2.bold");
      if (!variantTitleElement && shadeDetailsElement) {
        variantTitleElement = document.createElement("p");
        variantTitleElement.classList.add("paragraph-2", "bold", "waitlist-shade-title");
        shadeDetailsElement.prepend(variantTitleElement);
      }
      if (variantTitleElement) {
        variantTitleElement.textContent = selectedVariant?.title || selectedInput.value;
      }
  
      let variantDescriptionElement = waitlistModal.querySelector(".waitlist-modal__content-info .shade-details p.paragraph-3");
      if (!variantDescriptionElement && shadeDetailsElement) {
        variantDescriptionElement = document.createElement("p");
        variantDescriptionElement.classList.add("paragraph-3", "waitlist-shade-description");
        shadeDetailsElement.appendChild(variantDescriptionElement);
      }
      if (variantDescriptionElement) {
        variantDescriptionElement.textContent =
          selectedVariant?.metafields?.custom?.shade_description || selectedInput.dataset.variantDesc || "";
      }
  
      // variant image, if not found, create img element
      const shadeContainer = waitlistModal.querySelector(".waitlist-modal__content-info .shade-container");
      let variantImageElement = shadeContainer?.querySelector("img");
      if (!variantImageElement && shadeContainer) {
        variantImageElement = document.createElement("img");
        variantImageElement.classList.add("waitlist-shade-img");
        shadeContainer.prepend(variantImageElement);
      }
      if (variantImageElement) {
        variantImageElement.src =
          selectedVariant?.metafields?.custom?.shade_swatch || selectedInput.dataset.shadeSwatch || "";
        variantImageElement.alt = selectedVariant?.title || selectedInput.value || "";
      }
    }
  });
}

// remove waitlist modal duplications in the dom
function dedupeWaitlistModals() {
  const modals = Array.from(document.querySelectorAll('.waitlist-modal'));
  const buckets = new Map();
  modals.forEach((modal) => {
    const modalId = modal.id;
    if (modalId === 'Waitlist-Modal-product' || modalId === 'Waitlist-Modal-upsell' || modalId === 'Waitlist-Modal-recommendations') {
      if (!buckets.has(modalId)) buckets.set(modalId, []);
      buckets.get(modalId).push(modal);
    } else {
      modal.remove();
    }
  });

  // For each modal id, remove all but the most recently-added one
  buckets.forEach((list) => {
    if (list.length > 1) {
      // keep the newest instance, remove older ones
      list.slice(0, -1).forEach((m) => m.remove());
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  dedupeWaitlistModals();

  // init existing modals
  const waitlistModals = document.querySelectorAll('.waitlist-modal');
  waitlistModals.forEach((waitlistModal) => {
    window.initWaitlistModal(waitlistModal);
  });

  // observer that only reacts to new waitlist modals
  const observer = new MutationObserver((mutations) => {
    let newWaitlistFound = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains('waitlist-modal')) {
          newWaitlistFound = true;
        }
      });
    });

    if (newWaitlistFound) {
      dedupeWaitlistModals();
      const activeModals = document.querySelectorAll('.waitlist-modal');
      activeModals.forEach((waitlistModal) => {
        if (!waitlistModal.dataset.initialized) {
          window.initWaitlistModal(waitlistModal);
          waitlistModal.dataset.initialized = 'true';
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
